import React, { useEffect, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';

function TabVisitInKaryawan({
    visitIn
}) {

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (visitIn && visitIn.length > 0) {
            const dataTableFilter = visitIn.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const dateParts = data?.visitIn_time.split('T')[0].split('-');
                    const year = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const day = Number(dateParts[2]);

                    return {
                        ...data,
                        date: new Date(year, month, day),
                    };
                })
            );
        }
    }, [visitIn]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const colDefs = [
        {
            field: "date",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const date = params.value;
                if (date instanceof Date && !isNaN(date)) {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visitIn_time.split('T')[1].split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "visitIn_place",
            headerName: 'Lokasi Visit',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visitIn_place}
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    return (
        <div style={{ height: 500 }}>

            <AgGridReact
                theme={themeLightCold}
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // pagination={true}
                rowHeight={25}
            />

        </div>
    )
}

export default TabVisitInKaryawan
